import { render, staticRenderFns } from "./OrdensTransporteListagemPage.vue?vue&type=template&id=0b9979c8&"
import script from "./OrdensTransporteListagemPage.vue?vue&type=script&lang=js&"
export * from "./OrdensTransporteListagemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports